import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Button } from 'antd';
import {
  CustomImage,
  CustomModal,
  CustomAlertWarning,
  CustomTable,
  Text,
  useText,
} from '@src/components';
import digitalCardIncentiveCloseIcon from '@src/assets/icons/icn_kapat.svg';
import '../../../../styles/balanceUpload/similarOrder.scss';
import dayjs from '@src/utils/day';
import PropTypes from 'prop-types';
import { moneyFormat } from '@src/utils/utils';

const SimilarOrder = ({
  similarOrderModalVisible,
  setSimilarOrderModalVisible,
  handleOrderApproval,
}) => {
  const { orderDoubleCheck } = useSelector((state) => state?.balanceUpload);

  const SimilarHandleClose = useCallback(() => {
    setSimilarOrderModalVisible(false);
  }, [setSimilarOrderModalVisible]);

  const similarHandleCloseIconClick = () => {
    setSimilarOrderModalVisible(true);
  };

  const cancelHandleBtnClick = () => {
    setSimilarOrderModalVisible(false);
  };

  const message = useText('similarOrderWarning');

  const columns = [
    {
      title: '',
      width: 30,
    },
    {
      title: <Text t="nameUpperCase" />,
      dataIndex: 'firstName',
      key: 'firstName',
      width: 100,
    },
    {
      title: <Text t="surnameUpperCase" />,
      dataIndex: 'lastName',
      key: 'lastName',
      width: 100,
    },
    {
      title: <Text t="referenceCode3" />,
      dataIndex: 'refNo',
      key: 'refNo',
      width: 120,
    },
    {
      title: <Text t="cardNumber4" />,
      dataIndex: 'cardNumber',
      key: 'cardNumber',
      width: 140,
    },
    {
      title: <Text t="amountVatIncludedUpperCase" />,
      dataIndex: 'amount',
      key: 'amount',
      width: 100,
      ellipsis: true,
      render: (text) => <span>{text ? `${moneyFormat(text, false)}` : '0'}</span>,
    },
  ];

  const groupedOrders = new Map();
  if (orderDoubleCheck && Array.isArray(orderDoubleCheck.items)) {
    orderDoubleCheck.items.forEach((orderArray) => {
      orderArray.forEach((item) => {
        if (!groupedOrders.has(item.orderId)) {
          groupedOrders.set(item.orderId, []);
        }
        groupedOrders.get(item.orderId).push(item);
      });
    });
  }

  return (
    <CustomModal
      visible={similarOrderModalVisible}
      title={<Text t="pleaseNote" />}
      maskClosable={false}
      footer={false}
      onCancel={SimilarHandleClose}
      className="similar-order"
      width={925}
      closeIcon={
        <CustomImage
          className="similar-order-close"
          src={digitalCardIncentiveCloseIcon}
          alt="Close"
          onClick={similarHandleCloseIconClick}
        />
      }
    >
      <CustomAlertWarning message={message} className="similar-balance-alert" />
      <div className="similar-order-item-container">
        <div className="similar-orders">
          <Text t="similarOrders" />
        </div>
        {Array.from(groupedOrders.entries()).map(([orderId, items]) => (
          <React.Fragment key={orderId}>
            <div className="similar-order-detail">
              <div className="text-style-1">
                {dayjs(items[0].orderInputDate).format('DD.MM.YYYY HH:mm:ss ')}
              </div>
              <div className="text-style-2">
                <Text t="onDateSuffix" />
              </div>
              <div className="text-style-1">{orderId}</div>
              <div className="text-style-2">
                {' '}
                <Text t="movementHasBeenDetectedForTheFollowingCards" />
              </div>
            </div>
            <CustomTable
              columns={columns}
              pagination={false}
              dataSource={items}
              rowKey={(record) => `${record.orderId}-${record.cardNumber}`}
              className="similar-balance-table"
            />
          </React.Fragment>
        ))}
      </div>
      <div className="right-btn-container">
        <Button
          id="balanceUpload-orderSummary-main-cancel-btn"
          className="cancel-btn"
          onClick={cancelHandleBtnClick}
        >
          <Text t="giveUp" />
        </Button>
        <Button
          id="balanceUpload-orderSummary-main-next-btn"
          className="next-btn"
          onClick={(e) => handleOrderApproval(e, true)}
        >
          <Text t="approveOrder" />
        </Button>
      </div>
    </CustomModal>
  );
};

SimilarOrder.propTypes = {
  similarOrderModalVisible: PropTypes.bool.isRequired,
  setSimilarOrderModalVisible: PropTypes.func.isRequired,
  handleOrderApproval: PropTypes.func.isRequired,
};

export default SimilarOrder;
